import * as ActionTypes from '../UserSelection';

export function toggleSportMain(data) {
    return {type: ActionTypes.USER_SELECTION_TOGGLE_SPORT, section: 'main', data};
}

export function toggleSportPrematch(data) {
    return {type: ActionTypes.USER_SELECTION_TOGGLE_SPORT, section: 'preMatch', data};
}

export function toggleLeaguePrematch(data) {
    return {type: ActionTypes.USER_SELECTION_TOGGLE_LEAGUE, section: 'preMatch', data};
}

export function toggleMatchPrematch(data) {
    return {type: ActionTypes.USER_SELECTION_TOGGLE_MATCH, section: 'preMatch', data};
}

export function showAllPrematch(data) {
    return {type: ActionTypes.USER_SELECTION_SHOW_ALL, section: 'preMatch', data};
}

export function toggleSportLive(data) {
    return {type: ActionTypes.USER_SELECTION_TOGGLE_SPORT, section: 'live', data};
}

export function toggleLeagueLive(data) {
    return {type: ActionTypes.USER_SELECTION_TOGGLE_LEAGUE, section: 'live', data};
}

export function toggleMatchLive(data) {
    return {type: ActionTypes.USER_SELECTION_TOGGLE_MATCH, section: 'live', data};
}

export function showAllLive(data) {
    return {type: ActionTypes.USER_SELECTION_SHOW_ALL, section: 'live', data};
}


// WEBPACK FOOTER //
// ./js/actions/creators/UserSelection.js